import {isPlatformBrowser} from '@angular/common';
import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {MessageApiModel} from '../../../api/models/message.api.model';
import {RegistrationRestService} from '../../../api/services/registration.rest.service';
import {LoaderService} from '../../../core/services/loader.service';
import {ResponseErrorsHandlerService} from '../../../core/services/response-errors-handler.service';
import {ResponseNotificationService} from '../../../core/services/response-notification.service';

@Component({
  selector: 'app-registration-check-email',
  templateUrl: './registration-check-email.component.html',
  styleUrls: ['./registration-check-email.component.scss']
})
export class RegistrationCheckEmailComponent implements OnInit {

  public form: UntypedFormGroup;
  public isSubmitting = false;
  public hasPrefilledIdentifier = false;

  constructor(
    private readonly fb: UntypedFormBuilder,
    private readonly router: Router,
    private readonly registrationService: RegistrationRestService,
    private readonly loaderService: LoaderService,
    private readonly errorsHandler: ResponseErrorsHandlerService,
    private readonly notifications: ResponseNotificationService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
  ) {
    this.form = this.fb.group({
      usernameOrEmail: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    const usernameOrEmail = this.getUsernameOrEmailFromNavigationState();

    if (usernameOrEmail) {
      this.form.get('usernameOrEmail')?.setValue(usernameOrEmail);
      this.hasPrefilledIdentifier = true;
    }
  }

  resend(): void {
    if (this.form.invalid || this.isSubmitting) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    this.loaderService.show();
    this.registrationService.resendRegistrationConfirmation(this.form.get('usernameOrEmail')?.value)
      .subscribe({
        next: (response: MessageApiModel) => {
          this.notifications.emitMessage(response.message);
        },
        error: (errorResponse) => {
          this.errorsHandler.handleFormErrors(this.form, errorResponse);
        }
      })
      .add(() => {
        this.isSubmitting = false;
        this.loaderService.hide();
      });
  }

  private getUsernameOrEmailFromNavigationState(): string {
    const fromNavigation = this.router.getCurrentNavigation()?.extras.state?.['usernameOrEmail'];

    if (typeof fromNavigation === 'string' && fromNavigation.trim() !== '') {
      return fromNavigation;
    }

    if (!isPlatformBrowser(this.platformId)) {
      return '';
    }

    const browserState = window.history.state?.usernameOrEmail;
    return typeof browserState === 'string' ? browserState : '';
  }
}
